
export const contatoInfo = {
    email: "vidrosecoglass@gmail.com",
    telefone: "(15) 3358-5381",
    celular: "(15) 98125-7430",
    facebook: "www.facebook.com/ecoglassvidros",
    instagram: "www.instagram.com/ecoglassvidros",
    whatsappButton: "https://wa.me/5515981257430",
    telefoneButton: "5515981257430"
}